export const mapMember = <K, V>(map: Map<K, V>, key: K, getDefault: () => V): V => {
    if (!map.has(key)) {
        map.set(key, getDefault())
    }

    return map.get(key)!
}
